import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormulariosDiscapacidadComponent } from './formularios-discapacidad-old.component';
import { MatIconModule } from '@angular/material/icon';

import { FuseSharedModule } from '@fuse/shared.module';
import { FuseHighlightModule } from '@fuse/components';

const routes = [
    {
        path     : 'formularios-discapacidad-ospm',
        component: FormulariosDiscapacidadComponent
    }
  ];

@NgModule({
  declarations: [FormulariosDiscapacidadComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatIconModule,
    FuseSharedModule,
    FuseHighlightModule
    
  ]
})
export class FormulariosDiscapacidadModule { }
